/* eslint-disable camelcase */
// import initGeetest from './gt.js'
import React from 'react';
import PropTypes from 'prop-types';

const seewoCommonHost: Record<string, unknown> = {
  // dev: 'common-dev.test.seewo.com',
  dev: 'common.test.seewo.com',
  test: 'common.test.seewo.com',
  pro: 'common.seewo.com'
};

export interface ReactGeetestProps {
  appCode: string;
  env?: string;
  getRef?: (ref: ReactGeetest) => {};
  https?: boolean;
  lang?: string;
  loading: any;
  onReady?: (data: any) => void;
  onSuccess?: (data: any) => void;
  onFail?: (error: any) => void; // 二次验证失败
  onError?: (error: any) => void; // 行为验证失败
  onClose?: () => void;
  product?: 'float' | 'popup' | 'custom' | 'bind';
  style?: React.CSSProperties;
  timeout?: number;
  width?: string;
  needSecondVerify?: boolean; // 是否需要二次验证
}

export interface ReactGeetestState {
  isLoading: boolean;
}

export interface Config {
  gt: string;
  challenge: string;
  success: string;
}

export interface Validate {
  geetest_challenge: string;
  geetest_validate: string;
  geetest_seccode: string;
}

export default class ReactGeetest extends React.Component<ReactGeetestProps, ReactGeetestState> {
  uuid: string;
  captchaObj: any;

  constructor(props: ReactGeetestProps) {
    super(props);

    this.uuid = `geetest-${Date.now()}`;
    this.captchaObj = null;
  }

  static propTypes = {
    appCode: PropTypes.string.isRequired,
    env: PropTypes.string,
    getRef: PropTypes.func,
    https: PropTypes.bool,
    lang: PropTypes.string,
    loading: PropTypes.element,
    onReady: PropTypes.func,
    onSuccess: PropTypes.func,
    onFail: PropTypes.func,
    onError: PropTypes.func,
    onClose: PropTypes.func,
    product: PropTypes.oneOf(['float', 'popup', 'custom', 'bind']),
    style: PropTypes.object,
    timeout: PropTypes.number,
    width: PropTypes.string,
    needSecondVerify: PropTypes.bool
  };

  static defaultProps = {
    https: false,
    lang: 'zh-cn',
    loading: (
      <div className="geetest-loading-wrapper">
        <div className="geetest-loading-dot-wrapper">
          <div className="geetest-loading-dot"></div>
          <div className="geetest-loading-dot"></div>
          <div className="geetest-loading-dot"></div>
          <div className="geetest-loading-dot"></div>
        </div>
      </div>
    ),
    product: 'popup',
    style: {},
    timeout: 3000,
    width: '300px',
    needSecondVerify: false
  };

  state = {
    isLoading: true
  };

  componentDidMount() {
    // initGeetest前需保证gt.js加载完成
    let timmer = null;
    this.createScript().then(() => {
      timmer = setInterval(() => {
        console.log('createScript gt.js', window.initGeetest);
        if (window.initGeetest) {
          clearInterval(timmer);
          timmer = null;
          this.getVerifyConfig();
        }
      }, 500);
    });
  }

  getElementByAttr = (tag: string, attr: string, value: string) => {
    const htmlCollection: any = document.getElementsByTagName(tag);
    const elems = [...htmlCollection];
    const targetElems = [];

    for (let i = 0; i < elems.length; i++) {
      if (elems[i].getAttribute(attr) === value) {
        targetElems.push(elems[i]);
      }
    }
    return targetElems;
  };

  createScript = () => {
    return new Promise((resolve) => {
      const isExist = this.getElementByAttr('script', 'data-id', 'gt').length > 0;

      if (!isExist) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.setAttribute('data-id', 'gt');
        script.src = 'https://static.geetest.com/static/tools/gt.js';
        document.head.appendChild(script);
        resolve({});
      } else {
        resolve({});
      }
    });
  };

  getVerifyConfig = () => {
    const { onClose, onError, onReady, https, width, lang, product, timeout, needSecondVerify } = this.props;

    this.retry(this.getVerifyConfigReq.bind(this), 3)
      .then((xhr: any) => {
        // IE11 下 xhr.response 为 string 类型
        const res = typeof xhr.response === 'object' ? xhr.response : JSON.parse(xhr.response);
        const config: Config = res.data;
        window.initGeetest(
          {
            gt: config.gt,
            challenge: config.challenge,
            offline: !config.success,
            new_captcha: true,
            https,
            width,
            lang,
            product,
            timeout
          },
          (captchaObj: any) => {
            captchaObj
              .onReady(() => {
                onReady && onReady(captchaObj);
                this.setState(
                  {
                    isLoading: false
                  },
                  () => {
                    captchaObj.appendTo(`#${this.uuid}`);
                  }
                );
                this.captchaObj = captchaObj;
              })
              .onClose(() => {
                onClose && onClose();
              })
              .onSuccess(() => {
                const validate = captchaObj.getValidate();
                if (needSecondVerify) {
                  this.verify(validate);
                } else {
                  this.props.onSuccess &&
                    this.props.onSuccess({
                      key: validate.geetest_challenge,
                      captcha: validate.geetest_validate,
                      seccode: validate.geetest_seccode
                    });
                }
              })
              .onError((error) => {
                onError && onError(error);
              });
          }
        );
      })
      .catch(() => {
        onError && onError(new Error('初始化配置失败'));
      });
  };

  private getVerifyConfigReq = () => {
    const { appCode } = this.props;
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', `${this.getSeewoCommonHost()}/geetest/config?appCode=${appCode}&t=${new Date().getTime()}`);
      xhr.responseType = 'json';

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status !== 200) {
            reject(xhr.statusText);
          }
        }
      };

      xhr.onload = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          resolve(xhr);
        } else {
          reject(xhr.status);
        }
      };

      xhr.send();
    });
  };

  verify = (validate: Validate) => {
    const props = this.props;
    const postData = {
      challenge: validate.geetest_challenge,
      validate: validate.geetest_validate,
      seccode: validate.geetest_seccode
    };
    this.retry(this.verifyRequest.bind(this, postData), 3)
      .then(() => {
        props.onSuccess &&
          props.onSuccess({
            key: validate.geetest_challenge,
            captcha: validate.geetest_validate,
            seccode: validate.geetest_seccode
          });
      })
      .catch(() => {
        props.onFail && props.onFail(new Error('二次验证失败'));
      });
  };

  private verifyRequest = (data: any) => {
    const props = this.props;
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${this.getSeewoCommonHost()}/geetest/verify?appCode=${props.appCode}`);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.responseType = 'json';

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status !== 200) {
            reject(xhr.statusText);
          }
        }
      };

      xhr.onload = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve({});
          } else {
            reject(xhr.status);
          }
        }
      };

      xhr.send(JSON.stringify(data));
    });
  };

  private retry = (fn: any, times = 1) => {
    let promise: any = Promise.reject();
    for (let i = 0; i < times; i++) {
      promise = promise.catch(() => fn());
    }
    promise.catch(() => {
      console.warn(`Failed retrying ${times} times`);
    });
    return promise;
  };

  getSeewoCommonHost = () => {
    const env = this.getEnv();
    const host = seewoCommonHost[env];
    return `${this.props.https ? 'https' : 'http'}://${host}`;
  };

  getEnv = () => {
    const { env } = this.props;
    if (env) {
      return env;
    } else {
      const host = window.location.host;

      if (/dev\.test/.test(host) || /^\d+.\d+.\d+.\d+/.test(host) || /^localhost/.test(host)) {
        return 'dev';
      } else if (/\.test/.test(host)) {
        return 'test';
      } else {
        return 'pro';
      }
    }
  };

  render() {
    const { getRef, loading, style, width } = this.props;
    getRef && getRef(this as ReactGeetest);

    return (
      <div style={{ width, ...style }} id={this.uuid} className="react-geetest">
        {this.state.isLoading && loading}
      </div>
    );
  }
}
